/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const AUTH_ERROR = "AUTH_ERROR";
export const IS_ERROR = "IS_ERROR";
export const IS_ERROR_MSG = "IS_ERROR_MSG";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_BUNITS = "SET_BUNITS";
export const SET_FILE = "SET_FILE";
